import { Component, ViewChild, inject } from "@angular/core";
import { WartungshistoryComponent } from "../../wartungshistory-timeline/wartungshistory.component";
import { UserService } from "src/app/services/user.service";
import { AnlageDetailDto, AnlagenClientProvider } from "src/app/web-api/web-api";
import { ActivatedRoute } from "@angular/router";
import { CstNavigationService } from "src/app/services/cst-navigation.service";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Component({
    selector: "app-infoportal-api-elevators-display-wartungshistory",
    templateUrl: "./elevators-displayWartungshistory.component.html",
    styleUrls: ["./elevators-displayWartungshistory.component.scss", "../../styles.scss"],
    standalone: false
})
export class InfoportalApiElevatorDisplayWartungshistoryComponent {
    private _userService = inject(UserService);
    private _route = inject(ActivatedRoute);
    private _anlagenClient = inject(AnlagenClientProvider);
    private _navigation = inject(CstNavigationService);


    public anlagenIDToDisplay: number = null;
    public data: AnlageDetailDto = null;
    facilityNoInternal = "";
    
    @ViewChild(WartungshistoryComponent, { static: false})
    private _historyComp: WartungshistoryComponent;

    constructor(){
        this._route.paramMap.subscribe((params) => {
            this.anlagenIDToDisplay = +params.get("id"); // + um den string in eine number zu wandeln
            if (this.anlagenIDToDisplay) {
                this._LadeAnlage().subscribe();
            }
        });
    }

    public get user() {
        return this._userService?.CurrentUser;
    }
    public onFacilityNotesChanged() {
        if (!this._historyComp) {
          return;
        }
        this._historyComp.onSearchClick();
      }

      private _LadeAnlage(): Observable<any> {
        this.data = null;
        this.facilityNoInternal = "";
        return this._anlagenClient.getSingle(this.anlagenIDToDisplay).pipe(
            catchError((err) => {
                if (err.status === 403) {
                    this._navigation.navigateTo_Infoportal_Elevators();
                }
                return throwError(err);
            }),
            map((anlageDto) => {
                this.data = anlageDto;
                this.facilityNoInternal = this.data.anlageNrIntern;
                return anlageDto;
            })
        );
    }  
}